import { atom } from "recoil";

export const banksState = atom({
    key: 'banksState',
    default: []
})

export const bankFilterState = atom({
    key: 'bankFilterState',
    default: ''
})